var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cq-account-locked p-4"},[_c('div',{staticClass:"cq-account-content",domProps:{"innerHTML":_vm._s(_vm.html)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }